// extracted by mini-css-extract-plugin
module.exports = {"backContainer":"BackHeader_backContainer__2l9MC","icon":"BackHeader_icon__Hd9ni"};